import axios from 'axios';
import actions from '../actions/root';

export default {
	state: {
		links: [],
		linksLoaded: false,
		linksLoadedAuth: false,
		windowSize: {
			x: 0,
			y: 0,
		},
	},
	mutations: {
		[actions.SET_DATA]: (state, data) => {
			state.links = data;
			state.linksLoaded = true;
		},
		[actions.SET_DATA_AUTH]: (state, data) => {
			state.links = data;
			state.linksLoadedAuth = true;
		},
		[actions.REMOVE_DATA]: (state) => {
			state.links = [];
			state.linksLoaded = false;
		},
		[actions.SET_WINDOW_SIZE]: (state, size) => {
			state.windowSize = size;
		},
	},
	actions: {
		[actions.GET_ROOT_LINKS]: async ({ commit }) => {
			try {
				commit(actions.REMOVE_DATA);

				const response = await axios.get();

				const { data } = response;

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_ROOT_LINKS_AUTH]: async ({ commit }) => {
			try {
				const response = await axios.get();

				const { data } = response;

				commit(actions.SET_DATA_AUTH, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.CLEAR]: ({ commit }) => {
			commit(actions.REMOVE_DATA);
		},
	},
	getters: {
		LinksLoaded: state => state.linksLoaded,
		LinksLoadedAuth: state => state.linksLoadedAuth,
		WindowSize: state => state.windowSize,
	},
};
